import React from 'react'
import PropTypes from 'prop-types'

import { makeStyles } from '@material-ui/core/styles'
import { Box } from '@material-ui/core'
import Alert from '@material-ui/lab/Alert'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock'

const useStyles = makeStyles(() => ({
  alertContainer: {
    paddingBottom: '30px',
    margin: '0 auto',
  },
}))

const LockedBanner = ({ isEditing, isActivated }) => {
  const classes = useStyles()
  return (
    isEditing &&
    isActivated && (
      <Box className={classes.alertContainer}>
        <Alert
          color="info"
          severity="info"
          data-testid="alert"
          icon={<FontAwesomeIcon icon={faLock} />}
        >
          Certain sections of this page cannot be edited and are locked once the application is activated.
        </Alert>
      </Box>
    )
  )
}

LockedBanner.propTypes = {
  isEditing: PropTypes.bool.isRequired,
  isActivated: PropTypes.bool.isRequired,
}

export default LockedBanner
